import { Component } from 'react';
import BoxPost from './BoxPost';

class MainPost extends Component {
    render() {
        const { team = [] } = this.props;

        return (
			<div className="col-md-12 content-tab">
                <div className="content-inner">
                    {team.length === 0 ? (
                        <div className="row">
                            <div className="col-md-12 modern-profile-empty">
                                No team members to display.
                            </div>
                        </div>
                    ) : (
                        <div className="row modern-profile-grid">
                            {team.map((member) => (
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12" key={member.id}>
                                    <BoxPost member={member} />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default MainPost;
